module.exports = __webpack_public_path__ + "e8dd7e60348a70a85e82a3e1e6d1b7a0.svg";